"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _RichTextEditorError = _interopRequireDefault(require("./RichTextEditorError"));

var MAX_CRASH_RETRY_COUNT = 3;

var _default = function _default(_ref) {
  var connectRte = _ref.connectRte,
      RichTextEditor = _ref.RichTextEditor;

  var RichTextEditorComponent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(RichTextEditorComponent, _Component);

    function RichTextEditorComponent() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, RichTextEditorComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RichTextEditorComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        crashRetryCount: 0,
        enableManualRetry: true
      };

      _this.resetRetryCount = function () {
        _this.setState({
          crashRetryCount: 0,
          enableManualRetry: false
        });
      };

      _this.shouldResetAfterCrash = function () {
        var crashRetryCount = _this.state.crashRetryCount;

        if (crashRetryCount < MAX_CRASH_RETRY_COUNT) {
          _this.setState({
            crashRetryCount: crashRetryCount + 1
          });

          return true;
        }

        _this.setState({
          crashRetryCount: 0
        });

        return false;
      };

      return _this;
    }

    (0, _createClass2.default)(RichTextEditorComponent, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        this.RichTextEditor = connectRte(RichTextEditor);
      }
    }, {
      key: "render",
      value: function render() {
        var enableManualRetry = this.state.enableManualRetry;
        return _react.default.createElement(_ErrorBoundary.default, {
          shouldAutoReset: this.shouldResetAfterCrash,
          boundaryName: "EditableInteractionComponent_RichTextEditor",
          showRefreshAlert: false,
          ErrorComponent: _RichTextEditorError.default,
          errorProps: {
            resetRetryCount: this.resetRetryCount,
            enableManualRetry: enableManualRetry
          }
        }, _react.default.createElement(this.RichTextEditor, this.props));
      }
    }]);
    return RichTextEditorComponent;
  }(_react.Component);

  return RichTextEditorComponent;
};

exports.default = _default;
module.exports = exports.default;